module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "panel-title big-title"
  }, [_vm._v("\n            Rapport de dungeon Bowl\n        ")]), _vm._v(" "), _c('wizard', {
    attrs: {
      "step": 1,
      "isDB": true
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.current) ? _c('div', {
    staticClass: "panel-content"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-5 large-centered columns "
  }, [_c('div', {
    staticClass: "text-centered"
  }, [_vm._v("Date de la rencontre")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "language": "fr"
    },
    model: {
      value: (_vm.match_date),
      callback: function($$v) {
        _vm.match_date = $$v
      },
      expression: "match_date"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-2 columns large-centered"
  }, [_c('button', {
    staticClass: "full-width",
    on: {
      "click": _vm.validate
    }
  }, [_vm._v("Suivant")])])])]) : _c('div', [_c('spinner')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e412759"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/match-reports/mr-db-step-2.vue
// module id = 734
// module chunks = 0